<div class="flex flex-col gap-6 @container">
  <app-top-widget />
  <app-metrics-card class="md:hidden" />
  @if (currentUserIsSpecial) {
    <div class="flex flex-col @[882px]:flex-row gap-6 @[882px]:gap-8 w-full">
      <app-communitys-metrics class="@[882px]:w-[55%] w-full" />
      <app-community-growth class="@[882px]:w-[45%] w-full" />
    </div>
  } @else {
    <div
      data-testid="member-dashboard-grid"
      class="grid grid-cols-1 @[640px]:grid-cols-[minmax(0,436fr)_minmax(0,556fr)] @[1024px]:grid-cols-[436px_minmax(0,1fr)] gap-8 w-full"
    >
      <div data-testid="member-dashboard-left" class="flex flex-col min-w-0">
        @if (lessThan500Ganas) {
          <app-featured-promotions />
        } @else {
          <app-featured-rewards />
        }
      </div>
      <div data-testid="member-dashboard-right" class="flex flex-col gap-6 min-w-0">
        <app-active-missions />
        @if (lessThan500Ganas) {
          <app-featured-rewards />
        } @else {
          <app-featured-promotions />
        }
      </div>
    </div>
  }
</div>
